import Modal from 'apollo-react/components/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setDeleteEntityOfflineDataDialogOpen } from '../../../actions/DialogStatesActions';
import { deleteEntityFromLocalDB } from '../../../actions/OfflineDataActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import {
  getDeleteEntityOfflineDataId,
  getShowDeleteEntityOfflineData,
} from '../../../form-designer/selectors/common.selectors';

const DeleteEntityOfflineDataDialog = () => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const showDialog = useSelector(getShowDeleteEntityOfflineData);
  const entityId = useSelector(getDeleteEntityOfflineDataId);

  const handleDiscardChanges = () => {
    dispatch(deleteEntityFromLocalDB(entityId, true));
    dispatch(setDeleteEntityOfflineDataDialogOpen(false));
  };

  const handleCancel = () => {
    dispatch(setDeleteEntityOfflineDataDialogOpen(false));
  };

  return (
    <Modal
      open={showDialog}
      onClose={() => dispatch(setDeleteEntityOfflineDataDialogOpen(false))}
      title={translateString("Discard entity's changes?")}
      message={translateString(
        'You have unsynchronized local changes for this Task. Do you want to discard these changes?'
      )}
      buttonProps={[
        {
          label: translateString('Cancel'),
          onClick: handleCancel,
        },
        {
          label: translateString('Discard'),
          onClick: handleDiscardChanges,
        },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    />
  );
};

export default DeleteEntityOfflineDataDialog;
